import { render, staticRenderFns } from "./ConfigTabCustomFields.vue?vue&type=template&id=9de54dca"
import script from "./ConfigTabCustomFields.vue?vue&type=script&lang=js"
export * from "./ConfigTabCustomFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports